export const formatRating = (rating: number, omitTrailingZeros?: boolean) => {
  let formattedRating = rating.toFixed(1);
  if (omitTrailingZeros) {
    formattedRating = formattedRating.replace(/\.0$/, '');
  }
  return formattedRating as unknown as number;
};
